import React, { FC, ReactElement } from 'react'
import styles from './WalletHistoryItem.module.css'
import classNames from 'classnames'
import Wallet from '@/utils/wallet'
import { EXPLORER_URL } from '@/utils/constants'

const WalletHistoryItem: FC<{ data: any; address?: string }> = (props): ReactElement => {
	const data = props.data

	const { amount, womp } = React.useMemo(() => {
		const address = props.address || Wallet.getTaprootAddress()

		const inputs = data.vin
			.filter((e: any) => e.prevout.scriptpubkey_address === address)
			.reduce((a: any, e: any) => a + e.prevout.value, 0)
		const outputs = data.vout
			.filter((e: any) => e.scriptpubkey_address === address)
			.reduce((a: any, e: any) => a + e.value, 0)

		const sats = outputs - inputs
		return { amount: (sats / 1e8).toFixed(8), womp: sats < 0 }
	}, [data, props.address])

	return (
		<a href={`${EXPLORER_URL}/tx/${data.txid}`} target="_blank" className={styles.root}>
			<div className={classNames(styles.title, 'text-sm', 'medium')}>
				<span className={styles.womp}>{womp ? 'Sent' : 'Received'}</span>
				{data?.status?.confirmed && (
					<p className={classNames(styles.status, styles.confirmed, 'text-xs', 'regular')}>
						Confirmed
					</p>
				)}
				{!data?.status?.confirmed && (
					<p className={classNames(styles.status, styles.pending, 'text-xs', 'regular')}>Pending</p>
				)}
			</div>
			<div className={styles.body}>
				{!data?.status?.confirmed && (
					<p className={classNames(styles.timestamp, 'text-xs', 'regular')}>Unconfirmed</p>
				)}
				{data?.status?.confirmed && (
					<p className={classNames(styles.timestamp, 'text-xs', 'regular')}>
						{new Date(data?.status?.block_time * 1000).toLocaleString()}
					</p>
				)}
				<p className={classNames(styles.amount, 'text-sm', 'medium')}>
					{!womp && '+'}
					{amount}
				</p>
			</div>
		</a>
	)
}

export default WalletHistoryItem
